var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('v-overlay',{attrs:{"absolute":"","color":"#edd","opacity":"0.5"}},[_c('j-icon',{attrs:{"icon":"star","color":"#a03d41","size":"2x","spin":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }